module.exports = __webpack_public_path__ + "img/86-20.5399d367.png";